export default __webpack_public_path__ + "static/audio-cardio-b6762b6a11825857886e209b2a6786e9.svg";